import UsersService from "@/services/api/users.services";
import store from "@/store";

const state = {
  selectedLang: ''
}

const mutations = {
  CHANGE_LOCALE(state, payload) {
    state.selectedLang = payload
  },
  SET_LOCALE(state, payload) {
    state.selectedLang = payload
  }
}

const actions = {
  setDefaultLocale({ commit }, data) {
    commit('CHANGE_LOCALE', data)
  },
  changeLocale({ commit }, data) {
    console.log(1)
    return new Promise((resolve, reject) => {
      UsersService.post('updateProfileData', {}, data, {
        headers: {
          Accept: "*/*",
          "Content-Type": "multipart/form-data",
        },
      }).then((response) => {

        store.commit('authorization/SET_CURRENT_USER', response.data.data); // changing user`s language
        commit('CHANGE_LOCALE', data.language);
        return resolve(response);
      }).catch((error) => reject(error))
    })
  }
}

const getters = {
  getSelectedLocale: (state) => state.selectedLang
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
